var map = {
	"./Combined Shape.svg": [
		339,
		3
	],
	"./alert.svg": [
		340,
		4
	],
	"./archive.svg": [
		341,
		5
	],
	"./arrow-right.svg": [
		342,
		6
	],
	"./bank.svg": [
		343,
		7
	],
	"./bankid.svg": [
		344,
		8
	],
	"./barista.svg": [
		345,
		9
	],
	"./bartender.svg": [
		346,
		10
	],
	"./bell.svg": [
		347,
		11
	],
	"./calendar.svg": [
		348,
		12
	],
	"./camera.svg": [
		349,
		13
	],
	"./card.svg": [
		350,
		14
	],
	"./cashier.svg": [
		351,
		15
	],
	"./chat.svg": [
		352,
		16
	],
	"./checkmark.svg": [
		353,
		17
	],
	"./chef.svg": [
		354,
		18
	],
	"./chevron-down.svg": [
		355,
		19
	],
	"./chevron-left.svg": [
		356,
		20
	],
	"./chevron-right.svg": [
		357,
		21
	],
	"./chevron-up.svg": [
		358,
		22
	],
	"./clock.svg": [
		359,
		23
	],
	"./company.svg": [
		360,
		24
	],
	"./cross.svg": [
		361,
		25
	],
	"./dishwasher.svg": [
		362,
		26
	],
	"./document.svg": [
		363,
		27
	],
	"./doorman.svg": [
		364,
		28
	],
	"./duplicate.svg": [
		365,
		29
	],
	"./favorites-active.svg": [
		366,
		30
	],
	"./favorites-inactive.svg": [
		367,
		31
	],
	"./filter.svg": [
		368,
		32
	],
	"./hamburger.svg": [
		369,
		33
	],
	"./home-cleaning.svg": [
		370,
		34
	],
	"./hotel-cleaning.svg": [
		371,
		35
	],
	"./idbadge.svg": [
		372,
		36
	],
	"./image.svg": [
		373,
		37
	],
	"./kitchen.svg": [
		374,
		38
	],
	"./logout.svg": [
		375,
		39
	],
	"./mail.svg": [
		376,
		40
	],
	"./minus.svg": [
		377,
		41
	],
	"./minus_old.svg": [
		378,
		42
	],
	"./overflow.svg": [
		379,
		43
	],
	"./person.svg": [
		380,
		44
	],
	"./phone.svg": [
		381,
		45
	],
	"./pin.svg": [
		382,
		46
	],
	"./play.svg": [
		383,
		47
	],
	"./plus.svg": [
		384,
		48
	],
	"./plus_old.svg": [
		385,
		49
	],
	"./preparation.svg": [
		386,
		50
	],
	"./question.svg": [
		387,
		51
	],
	"./receipt.svg": [
		388,
		52
	],
	"./receptionist.svg": [
		389,
		53
	],
	"./search.svg": [
		390,
		54
	],
	"./security-guard.svg": [
		391,
		55
	],
	"./settings.svg": [
		392,
		56
	],
	"./share.svg": [
		393,
		57
	],
	"./trashcan.svg": [
		394,
		58
	],
	"./video.svg": [
		395,
		59
	],
	"./wallet.svg": [
		396,
		60
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 316;
module.exports = webpackAsyncContext;